// App Config

export const appConfig = {
  appName: "ULFA Registration App",
  eventName: "ULFA Inaugural Event 2026",
  googleSheetScriptUrl: process.env.REACT_APP_GOOGLE_SHEET_SCRIPT_URL,
};